import { Text } from '@heathmont/moon-components';
import type { Path } from 'react-hook-form';
import FormCheckbox from '~/client/shared/form/FormCheckbox';
import Translate from '~/client/shared/i18n/Translate';
import Stack from '~/client/shared/Stack';
import FlexStack from '~/client/shared/styles/FlexStack';
import type FormValues from '../../../Register/RegisterBody/FormRegister/useFormRegister/FormValues';

type Props = {
  optional: (field: Path<FormValues>) => {
    'data-testid': string;
  };
  offersLabel: {
    offersEmailLabel: string;
    offersSmsLabel: string;
    offersCallLabel: string;
  };
};

const MarketingOffers: FC<Props> = ({ optional, offersLabel }) => (
  <Stack>
    <Text size={14} color="trunks.100">
      <Translate id="profile.signup.marketing_consent" />
    </Text>
    <FlexStack inline alignItems="cneter">
      <FormCheckbox
        {...optional('offers')}
        label={offersLabel.offersEmailLabel}
        color="trunks.100"
      />
      <FormCheckbox
        {...optional('offersSms')}
        label={offersLabel.offersSmsLabel}
        color="trunks.100"
      />
      <FormCheckbox
        {...optional('offersCall')}
        label={offersLabel.offersCallLabel}
        color="trunks.100"
      />
    </FlexStack>
  </Stack>
);

export default MarketingOffers;
